/**
 * Mounted at the top of the panel-render branch of `ConversationAssistantConfigurer`.
 * Lifts the conversation-messages fetch to panel mount time instead of waiting for
 * `<ChatHistory>` to mount.
 */
import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import { useFireOnceOnRender } from '@atlassian/conversation-assistant-utils/useFireOnceOnRender';

import { useChatStore } from '../chat-store/useChatStore';
import { useChatStoreApi } from '../chat-store/useChatStoreApi';

export const WarmChatFetches = (): null => {
	const [{ currentConversationId }] = useChatStore();
	const { prefetchConversationMessages } = useChatStoreApi();

	const hasSelectedConversation =
		!!currentConversationId && currentConversationId !== EMPTY_CONVERSATION_ID;

	useFireOnceOnRender(hasSelectedConversation, () => {
		prefetchConversationMessages({
			conversationId: currentConversationId,
			skipNextFetch: true,
		});
	});

	return null;
};
